import * as _ from "lodash"; // eslint-disable-line no-unused-vars

// initial state
function initialState() {
  return {
    opportunity: {
      name: null,
      termId: null,
      siteId: null,
      translationalTeamId: null,
      description: null,
      positionsAvailable: null,
      opportunityCategoryId: null,
      opportunityTypeId: null,
      published: false,
      commitmentLevel: null,
      recommendedGpa: 2.0,
      recommendedCreditHoursString: null,
      applicationUrl: "",
      subjectCode: null,
      catalogNumber: null,
      scheduleLineNumber: null,
      unitsMinimum: null,
      unitsMaximum: null,
      locationCode: null,
      location: null,
      sessionCode: null,
      sessionLd: null,
      instructionMode: null,
      classStartDate: null,
      classEndDate: null,
      opportunityAdditionalMaterials: [],
      opportunityApplicationTypes: [],
      opportunityAreaOfInterests: [],
      opportunityInternshipCourses: [],
      opportunityRequirements: [],
      opportunityStudentActions: [],
      opportunitySiteContacts: [],
      studentOpportunities: []
    },
    opportunityType: null,
    siteContacts: [],
    // true if it is valid, false when dirty + invalid
    validationStates: {
      details: true,
      apply: true
    }
  };
}

const state = initialState;

// getters
const getters = {
  hasError: state => {
    return _.values(state.validationStates).some(function (validationState) {
      return !validationState;
    });
  }
};

// mutations
const mutations = {
  resetForm(state) {
    // acquire initial state
    var initState = initialState();
    // object is iterated over in this way so that the vuex state will remain reactive
    Object.keys(initState).forEach(key => {
      state[key] = initState[key];
    });
  },

  updateOpportunityName(state, value) {
    state.opportunity.name = value;
  },

  updateOpportunityCategoryId(state, value) {
    state.opportunity.opportunityCategoryId = value;
  },

  updateOpportunityTypeId(state, value) {
    state.opportunity.opportunityTypeId = value;
    // reset application types
    state.opportunity.opportunityApplicationTypes = [];
    //this.updateOpportunityApplicationTypes([]);
  },

  updateOpportunityType(state, value) {
    state.opportunityType = value;
  },

  updateSiteId(state, value) {
    state.opportunity.siteId = value;
  },

  updateTermId(state, value) {
    state.opportunity.termId = value;
  },

  updateTranslationalTeamId(state, value) {
    state.opportunity.translationalTeamId = value;
  },

  updatePositionsAvailable(state, value) {
    state.opportunity.positionsAvailable = value;
  },

  updateCommitmentLevel(state, value) {
    state.opportunity.commitmentLevel = value;
  },

  updateRecommendedGpa(state, value) {
    if (value === "") {
      state.opportunity.recommendedGpa = null;
    } else {
      state.opportunity.recommendedGpa = value;
    }
  },

  updateRecommendedCreditHoursString(state, value) {
    state.opportunity.recommendedCreditHoursString = value;
  },

  updateDescription(state, value) {
    state.opportunity.description = value;
  },

  updateOpportunityInternshipCourses(state, value) {
    state.opportunity.opportunityInternshipCourses = value;
  },

  updateOpportunityAreaOfInterests(state, value) {
    state.opportunity.opportunityAreaOfInterests = value;
  },

  updateOpportunityAdditionalMaterials(state, value) {
    state.opportunity.opportunityAdditionalMaterials = value;
  },

  updateOpportunityApplicationTypes(state, value) {
    state.opportunity.opportunityApplicationTypes = value;
  },

  updateOpportunitySiteContacts(state, value) {
    state.opportunity.opportunitySiteContacts = value;
  },

  updateApplicationUrl(state, value) {
    state.opportunity.applicationUrl = value;
  },

  updateScheduleLineNumber(state, value) {
    state.opportunity.scheduleLineNumber = value;
  },

  updateCatalogNumber(state, value) {
    state.opportunity.catalogNumber = value;
  },

  updateSubjectCode(state, value) {
    state.opportunity.subjectCode = value;
  },

  updateField(state, { field, value }) {
    state.opportunity[field] = value;
  },

  updateDetailsValidation(state, value) {
    state.validationStates.details = value;
  },

  updateApplyValidation(state, value) {
    state.validationStates.apply = value;
  },

  updateSiteContacts(state, value) {
    state.siteContacts = value;
  }
};

// actions
const actions = {
  // when opportunity type is changed, check to make sure category and areas of interest are still valid
  checkTypeValidity(context, opportunityType) {
    var categoryFound = _.find(
      opportunityType.opportunityTypeOpportunityCategories,
      function (opportunityTypeOpportunityCategory) {
        return (
          opportunityTypeOpportunityCategory.opportunityCategoryId ===
          context.state.opportunity.opportunityCategoryId
        );
      }
    );
    if (!categoryFound) {
      context.commit("updateOpportunityCategoryId", null);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
